import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  public set apiKey(apiKey: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('apiKey', apiKey);
    }
  }

  public get apiKey(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('apiKey') || '';
    }
    return '';
  }
}
